import request from '@/utils/request'

export function login(usercode, password) {
  return request({
    url: '/user/login',
    method: 'post',
    params: {
      usercode: usercode,
      password: password
    }
  })
}

export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function modifyPass(data) {
  return request({
    url: '/user/modify-password',
    method: 'post',
    data
  })
}
